import Vue from "vue";
import Router from "vue-router";

const Index = () => import("views/zwy/");
//首页
const Home = () => import("views/zwy/home/");
const DataState = () => import("views/zwy/home/data-state/DataState");
const OperateIndex = () => import("views/zwy/home/operate/index.vue");
const Operate = () => import("views/zwy/home/operate/Operate.vue");
const CustomerSingleReport = () => import("views/zwy/home/operate/CustomerSingleReport.vue");
const CustomerProductionDataIndex = () => import("views/zwy/home/production-data/index.vue");
const CustomerShipmentData = () => import("views/zwy/home/production-data/shipment-data/ShipmentData.vue");
const CustomerAfterSale = () => import("views/zwy/home/production-data/after-sale/after-sale.vue");
//数据导入
const DataImport = () => import("views/zwy/data-import/");
const StepGuide = () => import("views/zwy/data-import/step-guide/StepGuide");
const WmsOrder = () => import("views/zwy/data-import/wms/WmsOrder");
const RentalIncome = () =>
  import("views/zwy/data-import/rental-income/RentalIncome");
const OtherIncome = () => import("views/zwy/data-import/other-income/OtherIncome");
const Expenses = () => import("views/zwy/data-import/expenses/Expenses");
/* const IncomeExpenditure = () =>
  import("views/zwy/data-import/income-expenditure/IncomeExpenditure"); */
// 拦截入库列表
const InterceptWarehousing = () => import("views/zwy/data-import/other-expenses/intercept-warehousing");
// 数据录入(index)
const DataEntryIndex = () => import("views/zwy/data-import/data-entry/index.vue");
// 收货数据
const ReceivingData = () => import("views/zwy/data-import/data-entry/receiving-data/receiving-data.vue");
// 单量录入
const SingleQuantityEntry = () => import("views/zwy/data-import/data-entry/single-quantity-entry/single-quantity-entry.vue");
// 人工成本
const LaborCost = () => import("views/zwy/data-import/data-entry/labor-cost/labor-cost.vue");
// 盘点
const Inventory = () => import("views/zwy/data-import/data-entry/Inventory/Inventory.vue");
// 过期产品录入
const ExpiredProducts = () => import("views/zwy/data-import/data-entry/expired-products/expired-products.vue");
// 储位管理
const StorageManagement = () => import("views/zwy/data-import/data-entry/storage-management/storage-management.vue");
// 异常订单
const AbnormalOrder = () => import("views/zwy/data-import/data-entry/abnormal-order/abnormal-order.vue");

//成本计算
const Cost = () => import("views/zwy/cost/Cost");

//基础信息
const BaseInfoIndex = () => import("views/zwy/base-info/");
//项目管理
const ProjectManageIndex = () => import("views/zwy/base-info/project-manage/");
const ProjectListIndex = () => import("views/zwy/base-info/project-manage/project-list/");
const ProjectManage = () => import("views/zwy/base-info/project-manage/project-list/ProjectManage.vue");
const addProject = () => import("views/zwy/base-info/project-manage/project-list/addProject");
const CustomerList = () => import("views/zwy/base-info/project-manage/Customer-list.vue");
const EnteringExitingWarehouseIndex = () => import("views/zwy/base-info/project-manage/entering-exiting-warehouse/");
const EnteringExitingWarehouseList = () => import("views/zwy/base-info/project-manage/entering-exiting-warehouse/entering-exiting-warehouse-list.vue");
const EnteringExitingWarehouseDetails = () => import("views/zwy/base-info/project-manage/entering-exiting-warehouse/entering-exiting-warehouse-details.vue");

//仓库管理
const WarehouseManage = () => import("views/zwy/base-info/WarehouseManage");
const AddService = () => import("views/zwy/base-info/add-service");
const CopingWithHeader = () => import("views/zwy/base-info/coping-with-header");
const AccountsReceivableHeader = () => import("views/zwy/base-info/accounts-receivable-header");
const InvoiceInfo = () => import("views/zwy/base-info/invoice-info");
const InvoicedGoodsServices = () => import("views/zwy/base-info/invoiced-goods-services");
const GoodsInfo = () => import("views/zwy/base-info/goodsInfo.vue");
//承运商管理
const CarrierIndex = () => import("views/zwy/base-info/carrier/");
const CarrierArchives = () => import("views/zwy/base-info/carrier/Carrier.vue");
//客户快递规则
const Logistics = () => import("views/zwy/base-info/carrier/logistics/");
const LogisticsList = () =>
  import("views/zwy/base-info/carrier/logistics/LogisticsList");
const LogisticsDetail = () =>
  import("views/zwy/base-info/carrier/logistics/LogisticsDetail");
const AddLogistics = () => import("views/zwy/base-info/carrier/logistics/AddLogistics");
//承运商快递规则
const Express = () => import("views/zwy/base-info/carrier/express-inquiry/");
const ExpressInquiry = () =>
  import("views/zwy/base-info/carrier/express-inquiry/ExpressInquiry");
const AddExpress = () =>
  import("views/zwy/base-info/carrier/express-inquiry/AddExpress");
const ExpressDetail = () =>
  import("views/zwy/base-info/carrier/express-inquiry/ExpressDetail");
// 成本信息
  const CostInfo = () =>
    import("views/zwy/base-info/cost-info.vue");

// 服务
const ServiceIndex = () => import("views/zwy/service/");
const ChargeIndex = () =>
  import("views/zwy/service/charge-register/index");
const ChargeRegister = () =>
  import("views/zwy/service/charge-register/ChargeRegister");
const ChargeRecord = () =>
  import("views/zwy/service/charge-register/ChargeRecord");
const ClaimIndex = () =>
  import("views/zwy/service/claim-demage/index");
const ClaimRegister = () =>
  import("views/zwy/service/claim-demage/claim-register");
const ChargeTBCRecord = () =>
  import("views/zwy/service/claim-demage/tbc-record.vue");
const ChargeConfirmedRecord = () =>
  import("views/zwy/service/claim-demage/confirmed-record.vue");
const ReturnRegisterIndex = () =>
  import("views/zwy/service/return-register/index.vue");
const ReturnRegister = () =>
  import("views/zwy/service/return-register/return-register.vue");
const EnterWarehouseRegisterIndex = () =>
  import("views/zwy/service/enter-warehouse-register/");
const EnterWarehouseRegisterList = () =>
  import("views/zwy/service/enter-warehouse-register/enter-warehouse-register-list.vue");
const EnterWarehouseRegisterDetails = () =>
  import("views/zwy/service/enter-warehouse-register/enter-warehouse-register-details.vue");
const ExitWarehouseRegisterIndex = () =>
  import("views/zwy/service/exit-warehouse-register/");
const ExitWarehouseRegisterList = () =>
  import("views/zwy/service/exit-warehouse-register/exit-warehouse-register-list.vue");
const ExitWarehouseRegisterDetails = () =>
  import("views/zwy/service/exit-warehouse-register/exit-warehouse-register-details.vue");
const AccountsReceivableSettlementIndex = () =>
  import("views/zwy/service/accounts-receivable-settlement/");
const AccountsReceivableSettlement = () =>
  import("views/zwy/service/accounts-receivable-settlement/accounts-receivable-settlement.vue");
const SettlementOfAccountsPayableIndex = () =>
  import("views/zwy/service/settlement-of-accounts-payable/");
const SettlementOfAccountsPayable = () =>
  import("views/zwy/service/settlement-of-accounts-payable/settlement-of-accounts-payable.vue");
const StorageRegisterIndex = () =>
  import("views/zwy/service/storage-register/");
const StorageRegisterList = () =>
  import("views/zwy/service/storage-register/storage-register-list.vue");
const StorageRegisterDetailsIndex = () =>
  import("views/zwy/service/storage-register/storage-register-details/");
const StorageRegister = () =>
  import("views/zwy/service/storage-register/storage-register-details/storage-register.vue");
const StorageRegisterDetails = () =>
  import("views/zwy/service/storage-register/storage-register-details/storage-register-details.vue");

// 考勤
const AttendanceIndex = () => import("views/zwy/attendance/");
//员工管理
const Employee = () => import("views/zwy/employee/");
const EmployeeOrganization = () => import("views/zwy/employee/organization/");
const Organization = () => import("views/zwy/employee/organization/Organization");
const EmployeeSetting = () =>
  import("views/zwy/employee/organization/EmployeeSetting");
const RuleSetting = () =>
  import("views/zwy/employee/organization/RuleSetting");
const SalaryManagement = () =>
  import("views/zwy/employee/salary-management/SalaryManagement");
const AttendanceSetting = () =>
  import("views/zwy/employee/attendance-setting/AttendanceSetting");
const OvertimeRules = () =>
  import("views/zwy/employee/overtime-rules/OvertimeRules");
const TemporaryClock = () => import("views/zwy/employee/temporary-clock/TemporaryClock");
// 员工费用
const StaffCostsIndex = () => import("views/zwy/attendance/staff-costs/");
const Personnel = () => import("views/zwy/attendance/staff-costs/personnel-pay/");
const PersonnelPay = () =>
  import("views/zwy/attendance/staff-costs/personnel-pay/PersonnelPay");
const TemporaryPay = () =>
  import("views/zwy/attendance/staff-costs/temporary-pay/TemporaryPay");

//系统设置
const SystemSettingsIndex = () => import("views/zwy/system-settings/");
//用户管理(index)
const UserManage = () => import("views/zwy/system-settings/user-manage/");
const UserList = () => import("views/zwy/system-settings/user-manage/UserManage");
const UserAuthority = () => import("views/zwy/system-settings/user-manage/UserAuthority");
//易仓储推送配置
const PushConfigurationIndex = () => import("views/zwy/system-settings/push-configuration/");
const PushConfiguration = () => import("views/zwy/system-settings/push-configuration/push-configuration");
//易仓储部门分配
const DepartmentAllocationIndex = () => import("views/zwy/system-settings/department-allocation/");
const DepartmentAllocation = () => import("views/zwy/system-settings/department-allocation/department-allocation");

const Login = () => import("views/zwy/login/Login");
const BigScreen = () => import("views/zwy/big-screen/BigScreen");

// 财务
const FinanceIndex = () => import("views/zwy/finance/");
// 客户对账(index)
const FinancialReconciliation = () => import("views/zwy/finance/financial-reconciliation/");
const FinancialReconciliationList = () => import("views/zwy/finance/financial-reconciliation/FinancialReconciliation");
const BillDetails = () => import("views/zwy/finance/financial-reconciliation/BillDetails");
// 进出仓应收对账(index)
const InventoryReconciliation = () => import("views/zwy/finance/inventory-reconciliation/");
const InventoryReconciliationList = () => import("views/zwy/finance/inventory-reconciliation/inventory-reconciliation-list.vue");
const InventoryReconciliationDetails = () => import("views/zwy/finance/inventory-reconciliation/inventory-reconciliation-details.vue");
// 进出仓应付对账(index)
const ReconciliationOfAccountsPayable = () => import("views/zwy/finance/reconciliation-of-accounts-payable/");
const ReconciliationOfAccountsPayableList = () => import("views/zwy/finance/reconciliation-of-accounts-payable/reconciliation-of-accounts-payable-list.vue");
const ReconciliationOfAccountsPayableDetails = () => import("views/zwy/finance/reconciliation-of-accounts-payable/reconciliation-of-accounts-payable-details.vue");
// 进出仓应收开票(index)
const EntryExitInvoicing = () => import("views/zwy/finance/entry-exit-invoicing/");
const EntryExitInvoicingList = () => import("views/zwy/finance/entry-exit-invoicing/entry-exit-invoicing-list.vue");
const EntryExitInvoicingDetails = () => import("views/zwy/finance/entry-exit-invoicing/entry-exit-invoicing-details.vue");
// 进出仓应付提交(index)
const CopeWithSubmission = () => import("views/zwy/finance/cope-with-submission/");
const CopeWithSubmissionList = () => import("views/zwy/finance/cope-with-submission/cope-with-submission-list.vue");
const CopeWithSubmissionDetails = () => import("views/zwy/finance/cope-with-submission/cope-with-submission-details.vue");
// 进出仓利润统计（index）
const ProfitIndex = () => import("views/zwy/finance/profit/");
const Profit = () => import("views/zwy/finance/profit/profit.vue");
// 承运商对账（index）
const CarrierReconciliation = () => import("views/zwy/finance/carrier-reconciliation/");
const CarrierReconciliationList = () => import("views/zwy/finance/carrier-reconciliation/CarrierReconcliation.vue");
// 快递费用计算
const costCalculationIndex = () => import("views/zwy/finance/cost-calculation/");
const costCalculation = () => import("views/zwy/finance/cost-calculation/calculation");

// 智能验车
const SmartVehicleInspectionIndex = () => import("views/zwy/smart-vehicle-inspection/");
// 智能验车 - 作业中心
const HomeworkCenterIndex = () => import("views/zwy/smart-vehicle-inspection/homework-center/");
// 智能验车 - 作业中心 - 车辆影像档案
const ArchiveIndex = () => import("views/zwy/smart-vehicle-inspection/homework-center/archive/");
const CarArchive = () => import("views/zwy/smart-vehicle-inspection/homework-center/archive/car-archive.vue");
const CarArchiveDetails = () => import("views/zwy/smart-vehicle-inspection/homework-center/archive/car-archive-details.vue");
// 智能验车 - 作业中心 - 采集看板
const KanbanIndex = () => import("views/zwy/smart-vehicle-inspection/homework-center/kanban/");
const KanbanList = () => import("views/zwy/smart-vehicle-inspection/homework-center/kanban/kanban-list.vue");
const KanbanDetails = () => import("views/zwy/smart-vehicle-inspection/homework-center/kanban/kanban-details.vue");
// 智能验车 - 作业中心 - 批次管理
const BatchIndex = () => import("views/zwy/smart-vehicle-inspection/homework-center/batch/");
const BatchList = () => import("views/zwy/smart-vehicle-inspection/homework-center/batch/batch-list.vue");
const BatchDetails = () => import("views/zwy/smart-vehicle-inspection/homework-center/batch/batch-details.vue");
// 智能验车 - 人员与设备
const PersonnelEquipmentIndex = () => import("views/zwy/smart-vehicle-inspection/personnel-equipment");
// 智能验车 - 人员与设备 - 采集人员
const Collect = () => import("views/zwy/smart-vehicle-inspection/personnel-equipment/collect.vue");
// 智能验车 - 规则配置
const RuleConfigurationIndex = () => import("views/zwy/smart-vehicle-inspection/rule-configuration/");
// 智能验车 - 规则配置 - 品牌
const Brand = () => import("views/zwy/smart-vehicle-inspection/rule-configuration/Brand.vue");

// 信鸽货主端登录页
const CursomersLogin = () => import("views/customers/login/login.vue");
const CursomersIndex = () => import("views/customers/");
const CursomersOrderSearch = () => import("views/customers/order-search/order-search.vue");

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      component: Index,
      redirect: "/home",
      children: [
        {
          path: "/home",
          name: "home",
          component: Home,
          redirect: "/home/operateIndex",
          meta: {
            menuName: "数据中心"
          },
          children: [
            // {
            //   path: "data-state",
            //   name: "data-state",
            //   component: DataState,
            //   meta: {
            //     menuName: "数据发布"
            //   }
            // },
            {
              path: "operateIndex",
              name: "operateIndex",
              component: OperateIndex,
              redirect: "/home/operateIndex/operate",
              meta: {
                menuName: "运营数据",
              },
              children: [
                {
                  path: "operate",
                  name: "operate",
                  component: Operate,
                  meta: {
                    menuName: "仓库日报",
                    keepAlive: true
                  },
                },
                {
                  path: "customerSingleReport",
                  name: "customerSingleReport",
                  component: CustomerSingleReport,
                  meta: {
                    menuName: "客户单报"
                  },
                },
              ]
            },
            {
              path: "production-data",
              name: "production-data",
              component: CustomerProductionDataIndex,
              redirect: "/home/production-data/shipment-data",
              children: [
                {
                  path: "shipment-data",
                  name: "shipment-data",
                  component: CustomerShipmentData,
                  meta: {
                    menuName: "发货数据"
                  }
                },
                {
                  path: "after-sale",
                  name: "after-sale",
                  component: CustomerAfterSale,
                  meta: {
                    menuName: "售后数据"
                  }
                }
              ]
            },
          ]
        },
        {
          path: "/data-import",
          name: "/data-import",
          component: DataImport,
          redirect: "/data-import/step-guide",
          meta: {
            menuName: "数据导入"
          },
          children: [
            {
              path: "step-guide",
              name: "step-guide",
              component: StepGuide,
              meta: {
                menuName: "步骤指南"
              }
            },
            {
              path: "wms-order",
              name: "wms-order",
              component: WmsOrder,
              meta: {
                menuName: "异常修正"
              }
            },
            {
              path: "rental-income",
              name: "rental-income",
              component: RentalIncome,
              meta: {
                menuName: "场地面积录入"
              }
            },
            {
              path: "other-income",
              name: "other-income",
              component: OtherIncome,
              meta: {
                menuName: "其他收入"
              }
            },
            {
              path: "expenses",
              name: "expenses",
              component: Expenses,
              meta: {
                menuName: "相关费用"
              }
            },
            /* {
              path: "income-expenditure",
              name: "income-expenditure",
              component: IncomeExpenditure,
              meta: {
                menuName: "实际快递"
              }
            }, */
            {
              path: "intercept-warehousing",
              name: "intercept-warehousing",
              component: InterceptWarehousing,
              meta: {
                menuName: "拦截入库列表"
              }
            },
            {
              path: "data-entry",
              name: "data-entry",
              component: DataEntryIndex,
              redirect: "/data-import/data-entry/receiving-data",
              meta: {
                menuName: "数据录入"
              },
              children: [
                {
                  path: "receiving-data",
                  name: "receiving-data",
                  component: ReceivingData,
                  meta: {
                    menuName: "收货数据"
                  }
                },
                {
                  path: "single-quantity",
                  name: "single-quantity",
                  component: SingleQuantityEntry,
                  meta: {
                    menuName: "单量录入"
                  }
                },
                {
                  path: "labor-cost",
                  name: "labor-cost",
                  component: LaborCost,
                  meta: {
                    menuName: "人工成本"
                  }
                },
                {
                  path: "inventory",
                  name: "inventory",
                  component: Inventory,
                  meta: {
                    menuName: "盘点"
                  }
                },
                {
                  path: "expired-products",
                  name: "expired-products",
                  component: ExpiredProducts,
                  meta: {
                    menuName: "过期产品录入"
                  }
                },
                {
                  path: "storage-management",
                  name: "storage-management",
                  component: StorageManagement,
                  meta: {
                    menuName: "储位管理"
                  }
                },
                {
                  path: "abnormal-order",
                  name: "abnormal-order",
                  component: AbnormalOrder,
                  meta: {
                    menuName: "异常订单"
                  }
                }
              ]
            },
          ]
        },
        {
          path: "/cost",
          name: "/cost",
          component: Cost,
          meta: {
            menuName: "成本计算"
          }
        },
        {
          path: "/base-info",
          name: "/base-info",
          component: BaseInfoIndex,
          redirect: "/base-info/project-manage",
          meta: {
            menuName: "基础信息"
          },
          children: [
            {
              path: "project-manage",
              name: "project-manage",
              component: ProjectManageIndex,
              redirect: "/base-info/project-manage/customer-list",
              meta: {
                menuName: "项目管理"
              },
              children: [
                {
                  path: "customer-list",
                  name: "customer-list",
                  component: CustomerList,
                  meta: {
                    menuName: "客户列表"
                  },
                },
                {
                  path: "project-list",
                  name: "project-list",
                  component: ProjectListIndex,
                  redirect: "/base-info/project-manage/project-list/project-manage-list",
                  meta: {
                    menuName: "电商仓项目"
                  },
                  children: [
                    {
                      path: "project-manage-list",
                      name: "project-manage-list",
                      component: ProjectManage,
                    },
                    {
                      path: "add-project",
                      name: "add-project",
                      component: addProject,
                      meta: {
                        menuName: "新增电商仓项目"
                      },
                    },
                  ]
                },
                {
                  path: "entering-exiting-warehouse",
                  name: "entering-exiting-warehouse",
                  component: EnteringExitingWarehouseIndex,
                  redirect: "/base-info/project-manage/entering-exiting-warehouse/entering-exiting-warehouse-list",
                  meta: {
                    menuName: "进出仓项目"
                  },
                  children: [
                    {
                      path: "entering-exiting-warehouse-list",
                      name: "entering-exiting-warehouse-list",
                      component: EnteringExitingWarehouseList,
                    },
                    {
                      path: "entering-exiting-warehouse-details",
                      name: "entering-exiting-warehouse-details",
                      component: EnteringExitingWarehouseDetails,
                      meta: {
                        menuName: "进出仓项目详情"
                      },
                    },
                  ]
                },
              ]
            },
            {
              path: "warehouse-manage",
              name: "warehouse-manage",
              component: WarehouseManage,
              meta: {
                menuName: "仓库管理"
              }
            },
            {
              path: "carrier",
              name: "carrier",
              component: CarrierIndex,
              redirect: "/base-info/carrier/carrier-archives",
              meta: {
                menuName: "物流维护"
              },
              children: [
                {
                  path: "carrier-archives",
                  name: "carrier-archives",
                  component: CarrierArchives,
                  meta: {
                    menuName: "物流匹配规则"
                  }
                },
                {
                  path: "logistics",
                  name: "logistics",
                  component: Logistics,
                  redirect: "/base-info/carrier/logistics/logistics-list",
                  meta: {
                    menuName: "客户快递规则"
                  },
                  children: [
                    {
                      path: "logistics-list",
                      name: "logistics-list",
                      component: LogisticsList
                    },
                    {
                      path: "logistics-detail",
                      name: "logistics-detail",
                      component: LogisticsDetail,
                      meta: {
                        menuName: "规则详情"
                      }
                    },
                    {
                      path: "add-logistics",
                      name: "add-logistics",
                      component: AddLogistics,
                      meta: {
                        menuName: "添加规则"
                      }
                    }
                  ]
                },
                {
                  path: "express",
                  name: "express",
                  component: Express,
                  meta: {
                    menuName: "承运商快递规则"
                  },
                  redirect: "/base-info/carrier/express/express-inquiry",
                  children: [
                    {
                      path: "express-inquiry",
                      name: "express-inquiry",
                      component: ExpressInquiry
                    },
                    {
                      path: "add-express",
                      name: "add-express",
                      component: AddExpress,
                      meta: {
                        menuName: "新增快递"
                      }
                    },
                    {
                      path: "express-detail",
                      name: "express-detail",
                      component: ExpressDetail,
                      meta: {
                        menuName: "快递详情"
                      }
                    }
                  ]
                },
              ]
            },
            {
              path: "goods-info",
              name: "goods-info",
              component: GoodsInfo,
              meta: {
                menuName: "商品信息"
              }
            },
            {
              path: "cost-info",
              name: "cost-info",
              component: CostInfo,
              meta: {
                menuName: "成本信息"
              }
            },
            {
              path: "add-service-manage",
              name: "add-service-manage",
              component: AddService,
              meta: {
                menuName: "增值服务维护"
              }
            },
            {
              path: "coping-with-header",
              name: "coping-with-header",
              component: CopingWithHeader,
              meta: {
                menuName: "进出仓应付抬头"
              }
            },
            {
              path: "accounts-receivable-header",
              name: "accounts-receivable-header",
              component: AccountsReceivableHeader,
              meta: {
                menuName: "进出仓应收抬头"
              }
            },
            {
              path: "invoice-info",
              name: "invoice-info",
              component: InvoiceInfo,
              meta: {
                menuName: "进出仓开票信息"
              }
            },
            {
              path: "invoiced-goods-services",
              name: "invoiced-goods-services",
              component: InvoicedGoodsServices,
              meta: {
                menuName: "开票商品或劳务名称"
              }
            },
          ]
        },
        {
          path: "/system-settings",
          name: "/system-settings",
          component: SystemSettingsIndex,
          redirect: "/system-settings/user-manage",
          meta: {
            menuName: "系统设置"
          },
          children: [
            {
              path: "user-manage",
              name: "user-manage",
              component: UserManage,
              redirect: "/system-settings/user-manage/user-list",
              children: [
                {
                  path: "user-list",
                  name: "user-list",
                  component: UserList,
                  meta: {
                    menuName: "用户管理"
                  },
                },
                {
                  path: "user-authority",
                  name: "user-authority",
                  component: UserAuthority,
                  meta: {
                    menuName: "用户权限"
                  }
                }
              ]
            },
            {
              path: "push-configuration-index",
              name: "push-configuration-index",
              component: PushConfigurationIndex,
              redirect: "/system-settings/push-configuration-index/push-configuration",
              children: [
                {
                  path: "push-configuration",
                  name: "push-configuration",
                  component: PushConfiguration,
                  meta: {
                    menuName: "易仓储推送配置"
                  },
                }
              ]
            },
            {
              path: "department-allocation-index",
              name: "department-allocation-index",
              component: DepartmentAllocationIndex,
              redirect: "/system-settings/department-allocation-index/department-allocation",
              children: [
                {
                  path: "department-allocation",
                  name: "department-allocation",
                  component: DepartmentAllocation,
                  meta: {
                    menuName: "部门分配"
                  },
                }
              ]
            },
          ]
        },
        {
          path: "/finance",
          name: "finance",
          component: FinanceIndex,
          redirect: "/finance/financial-reconciliation",
          meta: {
            menuName: "财务"
          },
          children: [
            {
              path: "financial-reconciliation",
              name: "financial-reconciliation",
              component: FinancialReconciliation,
              redirect: "/finance/financial-reconciliation/financial-reconciliation-list",
              children: [
                {
                  path: "financial-reconciliation-list",
                  name: "financial-reconciliation-list",
                  component: FinancialReconciliationList,
                  meta: {
                    menuName: "客户对账"
                  },
                },
                {
                  path: "bill-details",
                  name: "bill-details",
                  component: BillDetails,
                  meta: {
                    menuName: "账单详情"
                  },
                }
              ]
            },
            {
              path: "carrier-reconciliation",
              name: "carrier-reconciliation",
              component: CarrierReconciliation,
              redirect: "/finance/carrier-reconciliation/carrier-reconciliation-list",
              meta: {
                menuName: "承运商对账"
              },
              children: [
                {
                  path: "carrier-reconciliation-list",
                  name: "carrier-reconciliation-list",
                  component: CarrierReconciliationList,
                },
              ]
            },
            {
              path: 'cost-calculation',
              name: "cost-calculation",
              component: costCalculationIndex,
              redirect: "/finance/cost-calculation/calculation",
              children: [
                {
                  path: 'calculation',
                  name: "calculation",
                  component: costCalculation,
                  meta: {
                    menuName: "快递费用计算"
                  },
                }
              ]
            },
            {
              path: 'inventory-reconciliation',
              name: "inventory-reconciliation",
              component: InventoryReconciliation,
              redirect: "/finance/inventory-reconciliation/inventory-reconciliation-list",
              children: [
                {
                  path: 'inventory-reconciliation-list',
                  name: "inventory-reconciliation-list",
                  component: InventoryReconciliationList,
                  meta: {
                    menuName: "进出仓应收对账"
                  }
                },
                {
                  path: 'inventory-reconciliation-details',
                  name: "inventory-reconciliation-details",
                  component: InventoryReconciliationDetails,
                  meta: {
                    menuName: "详情"
                  },
                }
              ]
            },
            {
              path: 'reconciliation-of-accounts-payable',
              name: "reconciliation-of-accounts-payable",
              component: ReconciliationOfAccountsPayable,
              redirect: "/finance/reconciliation-of-accounts-payable/reconciliation-of-accounts-payable-list",
              children: [
                {
                  path: 'reconciliation-of-accounts-payable-list',
                  name: "reconciliation-of-accounts-payable-list",
                  component: ReconciliationOfAccountsPayableList,
                  meta: {
                    menuName: "进出仓应付对账"
                  }
                },
                {
                  path: 'reconciliation-of-accounts-payable-details',
                  name: "reconciliation-of-accounts-payable-details",
                  component: ReconciliationOfAccountsPayableDetails,
                  meta: {
                    menuName: "详情"
                  },
                }
              ]
            },
            {
              path: 'entry-exit-invoicing',
              name: "entry-exit-invoicing",
              component: EntryExitInvoicing,
              redirect: "/finance/entry-exit-invoicing/entry-exit-invoicing-list",
              children: [
                {
                  path: 'entry-exit-invoicing-list',
                  name: "entry-exit-invoicing-list",
                  component: EntryExitInvoicingList,
                  meta: {
                    menuName: "进出仓应收开票"
                  }
                },
                {
                  path: 'entry-exit-invoicing-details',
                  name: "entry-exit-invoicing-details",
                  component: EntryExitInvoicingDetails,
                  meta: {
                    menuName: "详情"
                  },
                }
              ]
            },
            {
              path: 'cope-with-submission',
              name: "cope-with-submission",
              component: CopeWithSubmission,
              redirect: "/finance/cope-with-submission/cope-with-submission-list",
              children: [
                {
                  path: 'cope-with-submission-list',
                  name: "cope-with-submission-list",
                  component: CopeWithSubmissionList,
                  meta: {
                    menuName: "进出仓应付提交"
                  }
                },
                {
                  path: 'cope-with-submission-details',
                  name: "cope-with-submission-details",
                  component: CopeWithSubmissionDetails,
                  meta: {
                    menuName: "详情"
                  },
                }
              ]
            },
            {
              path: 'profit-index',
              name: "profit-index",
              component: ProfitIndex,
              redirect: "/finance/profit-index/profit",
              children: [
                {
                  path: 'profit',
                  name: "profit",
                  component: Profit,
                  meta: {
                    menuName: "进出仓利润统计"
                  }
                }
              ]
            }
          ]
        },
        {
          path: "/service",
          name: "service",
          component: ServiceIndex,
          redirect: "/service/charge-index",
          meta: {
            menuName: "服务"
          },
          children: [
            {
              path: "charge-index",
              name: "charge-index",
              component: ChargeIndex,
              redirect: "/service/charge-index/charge-register",
              children: [
                {
                  path: "charge-register",
                  name: "charge-register",
                  component: ChargeRegister,
                  meta: {
                    menuName: "收费登记"
                  }
                },
                {
                  path: "charge-record",
                  name: "charge-record",
                  component: ChargeRecord,
                  meta: {
                    menuName: "收费记录"
                  }
                },
              ]
            },
            {
              path: "claim-index",
              name: "claim-index",
              component: ClaimIndex,
              redirect: "/service/claim-index/claim-register",
              children: [
                {
                  path: "claim-register",
                  name: "claim-register",
                  component: ClaimRegister,
                  meta: {
                    menuName: "索赔登记"
                  }
                },
                {
                  path: "tbc-record",
                  name: "tbc-record",
                  component: ChargeTBCRecord,
                  meta: {
                    menuName: "待确认表单"
                  }
                },
                {
                  path: "confirmed-record",
                  name: "confirmed-record",
                  component: ChargeConfirmedRecord,
                  meta: {
                    menuName: "已确认表单"
                  }
                },
              ]
            },
            {
              path: "return-index",
              name: "return-index",
              component: ReturnRegisterIndex,
              redirect: "/service/return-index/return-register",
              children: [
                {
                  path: "return-register",
                  name: "return-register",
                  component: ReturnRegister,
                  meta: {
                    menuName: "退货登记"
                  }
                }
              ]
            },
            {
              path: "enter-warehouse-register-index",
              name: "enter-warehouse-register-index",
              component: EnterWarehouseRegisterIndex,
              redirect: "/service/enter-warehouse-register-index/enter-warehouse-register-list",
              children: [
                {
                  path: "enter-warehouse-register-list",
                  name: "enter-warehouse-register-list",
                  component: EnterWarehouseRegisterList,
                  meta: {
                    menuName: "进仓登记"
                  },
                },
                {
                  path: "enter-warehouse-register-details",
                  name: "enter-warehouse-register-details",
                  component: EnterWarehouseRegisterDetails,
                  meta: {
                    menuName: "登记"
                  }
                }
              ]
            },
            {
              path: "exit-warehouse-register-index",
              name: "exit-warehouse-register-index",
              component: ExitWarehouseRegisterIndex,
              redirect: "/service/exit-warehouse-register-index/exit-warehouse-register-list",
              children: [
                {
                  path: "exit-warehouse-register-list",
                  name: "exit-warehouse-register-list",
                  component: ExitWarehouseRegisterList,
                  meta: {
                    menuName: "出仓登记"
                  }
                },
                {
                  path: "exit-warehouse-register-details",
                  name: "exit-warehouse-register-details",
                  component: ExitWarehouseRegisterDetails,
                  meta: {
                    menuName: "登记"
                  }
                }
              ]
            },
            {
              path: "storage-register-index",
              name: "storage-register-index",
              component: StorageRegisterIndex,
              redirect: "/service/storage-register-index/storage-register-list",
              meta: {
                menuName: "存储登记"
              },
              children: [
                {
                  path: "storage-register-list",
                  name: "storage-register-list",
                  component: StorageRegisterList,
                },
                {
                  path: "storage-register-details-index",
                  name: "storage-register-details-index",
                  component: StorageRegisterDetailsIndex,
                  redirect: "/service/storage-register-index/storage-register-details-index/storage-register",
                  children: [
                    {
                      path: "storage-register",
                      name: "storage-register",
                      component: StorageRegister,
                      meta: {
                        menuName: "登记"
                      }
                    },
                    {
                      path: "storage-register-details",
                      name: "storage-register-details",
                      component: StorageRegisterDetails,
                      meta: {
                        menuName: "详情"
                      }
                    }
                  ]
                },
              ]
            },
            {
              path: "accounts-receivable-settlement-index",
              name: "accounts-receivable-settlement-index",
              component: AccountsReceivableSettlementIndex,
              redirect: "/service/accounts-receivable-settlement-index/accounts-receivable-settlement",
              children: [
                {
                  path: "accounts-receivable-settlement",
                  name: "accounts-receivable-settlement",
                  component: AccountsReceivableSettlement,
                  meta: {
                    menuName: "应收结算"
                  }
                }
              ]
            },
            {
              path: "settlement-of-accounts-payable-index",
              name: "settlement-of-accounts-payable-index",
              component: SettlementOfAccountsPayableIndex,
              redirect: "/service/settlement-of-accounts-payable-index/settlement-of-accounts-payable",
              children: [
                {
                  path: "settlement-of-accounts-payable",
                  name: "settlement-of-accounts-payable",
                  component: SettlementOfAccountsPayable,
                  meta: {
                    menuName: "应付结算"
                  }
                }
              ]
            }
          ]
        },
        {
          path: "/attendance",
          name: "attendance",
          component: AttendanceIndex,
          redirect: "/attendance/employee",
          meta: {
            menuName: "考勤"
          },
          children: [
            {
              path: "employee",
              name: "employee",
              component: Employee,
              redirect: "/attendance/employee/employee-organization",
              meta: {
                menuName: "员工管理"
              },
              children: [
                {
                  path: "employee-organization",
                  name: "employee-organization",
                  component: EmployeeOrganization,
                  redirect: "/attendance/employee/employee-organization/organization",
                  meta: {
                    menuName: "组织架构"
                  },
                  children: [
                    {
                      path: "organization",
                      name: "organization",
                      component: Organization
                    },
                    {
                      path: "employee-setting",
                      name: "employee-setting",
                      component: EmployeeSetting,
                      meta: {
                        menuName: "权限设置"
                      }
                    },
                    {
                      path: "rule-setting",
                      name: "rule-setting",
                      component: RuleSetting,
                      meta: {
                        menuName: "员工成本计算规则"
                      }
                    }
                  ]
                },
                {
                  path: "salary-management",
                  name: "salary-management",
                  component: SalaryManagement,
                  meta: {
                    menuName: "薪资管理"
                  }
                },
                {
                  path: "attendance-setting",
                  name: "attendance-setting",
                  component: AttendanceSetting,
                  meta: {
                    menuName: "出勤设置"
                  }
                },
                {
                  path: "overtime-rules",
                  name: "overtime-rules",
                  component: OvertimeRules,
                  meta: {
                    menuName: "加班规则"
                  }
                },
                {
                  path: "temporary-clock",
                  name: "temporary-clock",
                  component: TemporaryClock,
                  meta: {
                    menuName: "临时工打卡"
                  }
                }
              ]
            },
            {
              path: "staffCosts",
              name: "staffCosts",
              component: StaffCostsIndex,
              redirect: "/attendance/staffCosts/personnel",
              meta: {
                menuName: "员工费用"
              },
              children: [
                {
                  path: "personnel",
                  name: "personnel",
                  component: Personnel,
                  redirect: "/attendance/staffCosts/personnel/personnel-pay",
                  meta: {
                    menuName: "人员支出"
                  },
                  children: [
                    {
                      path: "personnel-pay",
                      name: "personnel-pay",
                      component: PersonnelPay
                    },
                  ]
                },
                {
                  path: "temporary-pay",
                  name: "temporary-pay",
                  component: TemporaryPay,
                  meta: {
                    menuName: "临时工支出"
                  }
                },
              ]
            }
          ]
        },
        {
          
          path: "/vehicle",
          name: "vehicle",
          component: SmartVehicleInspectionIndex,
          redirect: "/vehicle/homework-center",
          meta: {
            menuName: "智能验车"
          },
          children: [
            {
              path: "homework-center",
              name: "homework-center",
              component: HomeworkCenterIndex,
              redirect: "/vehicle/homework-center/archive",
              meta: {
                menuName: "作业中心"
              },
              children: [
                {
                  path: "archive",
                  name: "archive",
                  component: ArchiveIndex,
                  redirect: "/vehicle/homework-center/archive/car-archive",
                  meta: {
                    menuName: "车辆影像档案"
                  },
                  children: [
                    {
                      path: "car-archive",
                      name: "car-archive",
                      component: CarArchive,
                      meta: {
                        menuName: "车辆影像档案"
                      }
                    },
                    {
                      path: "car-archive-details",
                      name: "car-archive-details",
                      component: CarArchiveDetails,
                      meta: {
                        menuName: "车辆影像档案详情"
                      }
                    },
                  ]
                },
                {
                  path: "kanban",
                  name: "kanban",
                  component: KanbanIndex,
                  redirect: "/vehicle/homework-center/kanban/kanban-list",
                  meta: {
                    menuName: "采集看板"
                  },
                  children: [
                    {
                      path: "kanban-list",
                      name: "kanban-list",
                      component: KanbanList,
                      meta: {
                        menuName: "采集看板"
                      }
                    },
                    {
                      path: "kanban-details",
                      name: "kanban-details",
                      component: KanbanDetails,
                      meta: {
                        menuName: "采集看板详情"
                      }
                    }
                  ]
                },
                {
                  path: "batch",
                  name: "batch",
                  component: BatchIndex,
                  redirect: "/vehicle/homework-center/batch/batch-list",
                  meta: {
                    menuName: "批次管理"
                  },
                  children: [
                    {
                      path: "batch-list",
                      name: "batch-list",
                      component: BatchList,
                      meta: {
                        menuName: "批次管理"
                      }
                    },
                    {
                      path: "batch-details",
                      name: "batch-details",
                      component: BatchDetails,
                      meta: {
                        menuName: "批次管理详情"
                      }
                    }
                  ]
                },
              ]
            },
            {
              path: "personnel-equipment",
              name: "personnel-equipment",
              component: PersonnelEquipmentIndex,
              redirect: "/vehicle/personnel-equipment/collect",
              meta: {
                menuName: "人员与设备"
              },
              children: [
                {
                  path: "collect",
                  name: "collect",
                  component: Collect,
                  meta: {
                    menuName: "采集人员"
                  },
                }
              ]
            },
            {
              path: "rule-configuration",
              name: "rule-configuration",
              component: RuleConfigurationIndex,
              redirect: "/vehicle/rule-configuration/brand",
              meta: {
                menuName: "规则配置"
              },
              children: [
                {
                  path: "brand",
                  name: "brand",
                  component: Brand,
                  meta: {
                    menuName: "品牌维护"
                  }
                }
              ]
            }
          ]
        }
      ]
    },
    {
      path: "/login",
      component: Login
    },
    {
      path: "/big-screen",
      component: BigScreen
    },
    {
      // 信鸽货主端登录页面
      path: '/customers-login',
      component: CursomersLogin
    },
    {
      path: '/customers',
      component: CursomersIndex,
      redirect: '/customers/order-search',
      children: [
        {
          path: 'order-search',
          name: 'order-search',
          component: CursomersOrderSearch,
          meta: { title: '订单查询' },
        }
      ]
    },
  ]
});

router.afterEach((to) => {
  if (to.path === '/project-manage/add-project') {
    if (to.query.isFlag == 1) {
      to.meta.menuName = '新增'
    } else if (to.query.isFlag == 2) {
      to.meta.menuName = '编辑'
    } else if (to.query.isFlag == 3) {
      to.meta.menuName = '详情'
    }
  }
  // if (document.getElementById("pageContent")) {
  //   document.getElementById("pageContent").scrollTop = 0;
  // }
});

export default router;
